// extracted by mini-css-extract-plugin
export default {"ranger":"FourImagesServices_ranger__ho3Kz"};